export const CREATING_CLIENT         = "CREATING_CLIENT";

export const FETCHING_CLIENTS        = "FETCHING_CLIENTS";
export const FETCHING_CLIENT         = "FETCHING_CLIENT";
export const FETCHING_SB_TICKETS     = "FETCHING_SB_TICKETS";

export const UPDATING_CLIENT         = "UPDATING_CLIENT";
export const UPDATING_CLIENT_IMAGE   = "UPDATING_CLIENT_IMAGE";
export const UPDATING_CLIENT_CONTACT = "UPDATING_CLIENT_CONTACT";
